<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <VouchersNav></VouchersNav>
        </b-col>
      </b-row>
    </div>
    <div>
      <div class="vouchers-body">
        <div class="vouchers-content">
          <b-row>
            <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-form-select v-model="selectedVoucher" :options="voucherOptions" @input="filterVouchers()" />
              </div>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-input-group prepend>
                  <b-form-input
                    @keyup.native="search(true)"
                    placeholder="Search"
                    v-model="searchString"
                  ></b-form-input>
                  <b-dropdown text="Advanced" variant="primary" slot="append">
                    <b-dropdown-item
                      v-for="searchField in searchableFields"
                      :key="searchField.value"
                      @click="searchOption(searchField.value)"
                    >
                      {{ searchField.text }}
                      <i
                        v-if="selectedSearchOption === searchField.value"
                        class="ml-1"
                      >
                        <img
                          width="15"
                          height="15"
                          src="@/assets/images/checked-symbol.svg"
                          alt
                          class="mr-1"
                          style="margin-top: -2px; margin-right: 0px;"
                        />
                      </i>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </div>
            </b-col>
            <b-col sm="3" md="3">
              <b-button
                variant="primary"
                class="d-inline-block new-button align-top"
                @click="showModal('new-voucher')"
              >+ New Voucher</b-button>
              <AddVoucher :image="form.image" @clearImage="clearVoucherImg"></AddVoucher>
            </b-col>
            <b-col class="text-left text-md-right">
              <b-button variant="primary btn-table-export" @click="exportVouchers()">Export</b-button>
            </b-col>
          </b-row>
          <div class="vouchers">
            <div class="data-container">
              <b-table
                responsive
                :items="isSearchType ? [] : vouchers"
                :fields="fields"
                show-empty
                :empty-text="emptyText"
              >
                <template slot="image" slot-scope="data">
                  <div id="voucher-image" class="border">
                    <img v-if="data.item.image !== ''" :src="data.item.image" alt="Voucher Image" />
                  </div>
                </template>
                <template slot="visibility" slot-scope="data">
                  <div id="voucher-visibility">
                    <switches
                      v-model="data.item.visibility"
                      :emit-on-mount="false"
                      theme="custom"
                      color="primary"
                      text-enabled="On"
                      text-disabled="Off"
                      type-bold="true"
                      disabled
                    ></switches>
                  </div>
                </template>
                <template slot="uuid" slot-scope="data">
                  <i class="action-button mr-2 d-inline-block">
                    <img
                      src="@/assets/images/actions/edit.svg"
                      alt="Edit Button"
                      @click="callDisplay(data.item.uuid)"
                    />
                  </i>
                  <i class="action-button d-inline-block">
                    <img
                      src="@/assets/images/actions/delete.svg"
                      alt="Delete Button"
                      @click="callDelete(data.item.uuid, data.item.name)"
                    />
                  </i>
                </template>
              </b-table>
            </div>
          </div>
          <div>
            <b-row>
              <b-col>
                <div class="mt-1">
                  <span
                    class="pagination-indicator"
                  >{{ currentFirstItem }}-{{ currentLastItem }} of {{ maxPage }} pages</span>
                  
                  <b-pagination
                    hide-goto-end-buttons
                    align="left"
                    size="md"
                    :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                    :limit="(totalPerPage > 0 ) ? 3 : 1"
                    :per-page="totalPerPage"
                    @change="paginate"
                    class="custom-pagination-arrow-only mb-0 ml-2"
                  ></b-pagination>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="voucherUploadImage"
      title="Upload Image"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div id="voucher-image-upload-container" class="border mx-auto">
        <croppa
          v-model="croppa"
          @new-image-drawn="onNewImage"
          @zoom="onZoom"
          :width="350"
          :height="200"
          placeholder="Choose an Image"
          :show-remove-button="true"
          :placeholder-font-size="14"
          remove-button-color="#ff8828"
        ></croppa>
      </div>
      <div id="voucher-image-range-container" class="mx-auto mt-2">
        <input
          type="range"
          class="custom-range"
          id="customRange1"
          @input="onSliderChange"
          :min="sliderMin"
          :max="sliderMax"
          step=".001"
          v-model="sliderVal"
        />
      </div>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          class="btn-cancel"
          @click="cancelUploadImageModal(true)"
          style="margin-right: .25rem;"
        >Cancel</b-button>
        <b-button
          variant="primary"
          @click="hideUploadImageModal(true)"
          style="margin-left: .25rem;"
        >Save</b-button>
      </div>
    </b-modal>
    <EditVoucher :form="voucherDetails" :image="form.image" @clearImage="clearVoucherImg"></EditVoucher>
    <b-modal id="delete-modal" title="Confirm Delete">
      <p class="modal-main-message">
        Are you sure you want to delete
        <strong>{{ deleteVoucherName }}</strong>?
      </p>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          v-bind:disabled="loading"
          class="btn-cancel"
          style="margin-right: .25rem;"
          @click="hideModal('delete-modal')"
        >Cancel</b-button>
        <b-button
          variant="primary"
          v-bind:disabled="loading"
          style="margin-left: .25rem;"
          @click="deleteVoucher"
        >
          <template v-if="loading">Deleting...</template>
          <template v-else>Yes, Delete</template>
        </b-button>
        <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VouchersNav from "./VouchersNav.vue";
import Switches from "vue-switches";
import { mapState } from "vuex";
import AddVoucher from "./AddVoucher";
import EditVoucher from "./EditVoucher";

export default {
  name: "vouchers",
  data() {
    return {
      selectedVoucher: "all",
      voucherOptions: [
        { value: "all", text: "All Vouchers" },
        { value: "active", text: "Active Vouchers" },
        { value: "inactive", text: "Inactive Vouchers" }
      ],
      fields: [
        "image",
        "name",
        "description",
        "visibility",
        { key: "uuid", label: "Action" }
      ],
      form: {
        image: ""
      },
      croppa: {},
      croppaLogoStamp: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      deleteUuid: "",
      deleteVoucherName: "",
      emptyText: "No Records Found",
      isSearchType: false,
      searchString: "",
      selectedSearchOption: "all",
      searchPayload: null
    };
  },
  components: {
    VouchersNav,
    Switches,
    AddVoucher,
    EditVoucher
  },
  computed: {
    ...mapState("vouchers", [
      "vouchers",
      "voucherDetails",
      "loading",
      "maxPage",
      "nextPage",
      "prevPage",
      "currentPage",
      "totalPerPage",
      "searching",
      "currentFirstItem",
      "currentLastItem",
      "initialPageCount",
      "errors",
      "editing",
      "searchableFields"
    ])
  },
  created() {
    this.getVouchers(1);
  },
  methods: {
    async getVouchers(page) {
      let param = {
        page: page,
        payload: this.searchPayload
      };
      await this.$store.dispatch("vouchers/getVouchers", param);
    },
    async filterVouchers() {
      let param = {
        page: 1,
        payload: {
          keyword: "",
          filter: this.selectedVoucher
        }
      };
      await this.$store.dispatch("vouchers/getVouchers", param);
    },
    async showModal(modal) {
      (await (modal == "edit-modal"))
        ? this.$store.dispatch("vouchers/editing")
        : this.$store.dispatch("vouchers/resetEditing");

      this.$store.dispatch("vouchers/resetErrors");

      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    onNewImage() {
      this.sliderVal = this.croppa.scaleRatio;
      this.sliderMin = this.croppa.scaleRatio / 2;
      this.sliderMax = this.croppa.scaleRatio * 2;
    },
    onSliderChange(evt) {
      var increment = evt.target.value;
      this.croppa.scaleRatio = +increment;
    },
    onZoom() {
      this.sliderVal = this.croppa.scaleRatio;
    },
    cancelUploadImageModal(forceClose = false) {
      this.clearVoucherImg();
      if (forceClose) {
        this.hideModal("voucherUploadImage");
        this.editing
          ? this.showModal("edit-modal")
          : this.showModal("new-voucher");
      }
      return true;
    },
    hideUploadImageModal(forceClose = false) {
      if (this.croppa.generateDataUrl() === "") {
        return false;
      }

      this.form.image = this.croppa.generateDataUrl();

      if (forceClose) {
        this.hideModal("voucherUploadImage");
        this.editing
          ? this.showModal("edit-modal")
          : this.showModal("new-voucher");
      }
      return true;
    },
    clearVoucherImg: function() {
      this.form.image = "";
      this.croppa.remove();
    },
    deleteVoucher() {
      let param = {
        uuid: this.deleteUuid
      };

      let _this = this;
      this.$store.dispatch("vouchers/deleteVoucher", param).then(function() {
        
        // if (_this.errors == null) _this.getPackages(_this.currentPage);
        if (_this.errors == null) {
          _this.hideModal("delete-modal");
          _this.getVouchers(1);
        } else {
          _this.callDelete(_this.deleteUuid, _this.deleteVoucherName);
        }
      });
    },
    paginate(page) {
      //   if (this.searching) {
      //     return this.search(false, page);
      //   }

      return this.getVouchers(page);
    },
    async callDisplay(uuid) {
      let _this = this;

      this.$store.dispatch("vouchers/editing");

      await this.$store.dispatch("vouchers/viewVoucher", uuid).then(function() {
        _this.showModal("edit-modal");
      });
    },
    callDelete(uuid, voucherName) {
      this.deleteUuid = uuid;
      this.deleteVoucherName = voucherName;
      this.showModal("delete-modal");
    },
    search(newSearch = false, page) {
      let param = {
        payload: {
          filter: this.selectedSearchOption,
          keyword: this.searchString
        },
        page: newSearch === true ? 1 : page
      };

      if (this.searchString.trim() === "") {
        return this.getVouchers(1);
      }
      if (newSearch) {
        this.emptyText = "Searching...";
        this.isSearchType = true;
      }
      let _this = this;
      this.$store.dispatch("vouchers/getVouchers", param).then(() => {
        _this.emptyText = 'No Records Found for "' + _this.searchString + '"';
        _this.isSearchType = false;
      });
    },
    searchOption(value) {
      this.selectedSearchOption = value;
      if (this.searchString.trim() !== "") {
        this.search(true);
      }
    },
    exportVouchers() {
      let param = {
        payload: {
          filter: this.selectedSearchOption,
          keyword: this.searchString
        },
      };

      console.log(param);

      this.$store.dispatch("vouchers/exportVouchers", param);
    }
  }
};
</script>
<style scoped>
</style>